export { default } from "./DetallesPedido";
